module.exports = __webpack_public_path__ + "static/img/background-about.ab8422d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-about.png
// module id = +9Bp
// module chunks = 1